var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('StageReportCompletedHeaderIcon'),_c('h1',{staticClass:"stage-report-completed-header"},[_vm._v(" "+_vm._s(_vm.orderModule.titleWithoutHash)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }